import { render, staticRenderFns } from "./ItineraryInfoDayServices.vue?vue&type=template&id=54ad04a8&"
import script from "./ItineraryInfoDayServices.vue?vue&type=script&lang=js&"
export * from "./ItineraryInfoDayServices.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryInfoDayServices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports